var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"editor",attrs:{"name":_vm.name,"id":_vm.generatedId},domProps:{"value":(_vm.currentValue)},on:{"input":function($event){if($event.target.composing)return;_vm.currentValue=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }